// user action types
export const LOADING_UPDATE = 'LOADING_UPDATE';

export default {
  LOADING_UPDATE
};
